module.exports = __webpack_public_path__ + "static/media/tutorial2.06abe254.png";